import request from "../../utils/http-client"

// TODO if we load content via Ajax
export const loadHTML = (
  endpoint = ""
): Promise<void | {
  htmlValue?: string
}> => {
  return request({
    url: endpoint,
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    }
  }).then((res) => {
    if (res.data) {
      return (
        {
          htmlValue: res.data.htmlValue
        } || {}
      )
    }
  })
}

export const postHTML = (
  htmlValue: string,
  inputName: string,
  endpoint = "/admin/custom-screens"
): Promise<void | {
  isSuccess?: boolean
}> => {
  // endpoint currently requires data as FormData
  const formData = new FormData()
  formData.append("_method", "patch")
  formData.append(inputName, htmlValue)

  return request({
    url: endpoint,
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content")
    }
  }).then((res) => {
    if (res.data) {
      if (res.status === 200) {
        return (
          {
            isSuccess: true
          } || {}
        )
      } else if (res.status === 400) {
        return {
          isSuccess: false
        }
      }
    }
  })
}
